(function(){	var loadScript = function(url, callback){	var script = document.createElement("script"); script.type = "text/javascript"; if (script.readyState){ script.onreadystatechange = function(){ if (script.readyState == "loaded" || script.readyState == "complete"){ 	script.onreadystatechange = null; 	callback(); } }; } else { script.onload = function(){ callback(); }; } script.src = url;	document.getElementsByTagName("head")[0].appendChild(script); }; var fix = function($){	var ml_lang;
	var listen = false;

	window.ml_domains_local = {};

    function interceptCartSubmit()
	{
		$('form[action="/cart"] input[name="checkout"],form[action="/cart"] button[name=checkout], a[href="/checkout"],button.shopify-payment-button__button').click(function(e)
		{
			e.preventDefault();
			var note_f = $('textarea[name=note]');
			var note = '';
			if(note_f.length > 0)
			{
				if(note_f.val().length > 0)
					note='&note='+note_f.val();
			}

			location.href='/checkout?locale='+ml_lang+note;
		});
	}

	function setCookie(v)
	{
		document.cookie = "redirected="+v+"; path=/;";
	}

	function delCookie()
	{
		document.cookie = "redirected=; path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC";
	}

	function getCookie() 
	{
    	var name = "redirected=";
   	 	var ca = document.cookie.split(';');
    	for(var i = 0; i < ca.length; i++) 
    	{
        	var c = ca[i];
        	while (c.charAt(0)==' ') 
            	c = c.substring(1);
        	
        	if (c.indexOf(name) == 0) {   return c.substring(name.length,c.length);      }
    	}
    	return "";
	}
		
	function swap(json)
	{
  		var ret = {};
  		for(var key in json)
    		ret[json[key]] = key;
  
  		return ret;
	}	
		
	function getUrlVars()
	{   

		var vars = []; 
		var jvars = {};
		var hash;

		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		var cloc =  window.location.host;	
	    			    	
    	for(var i = 0; i < hashes.length; i++)
    	{
       		hash = hashes[i].split('=');
        	if(hash[1]!=null) 
        		jvars[hash[0]] = hash[1];
    	}
    	return jvars;
	}
	
	
	window.setAtt = function(target,reload=true)
	{
		var url = location.href.split('?');	
		if(url[0].charAt(url[0].length-1) =='#')
			url[0]=url[0].substr(0,url[0].length-1);
		var new_qs_arr = [];
		var new_qs = '';
		var qs = getUrlVars();
	
		for(var j=0; j< qs.length; j++)
		{
			if(qs[j]!='lang')
				new_qs_arr.push(qs[j]+'='+qs[qs[j]]);
		}
		new_qs = new_qs_arr.join('&');
		if(new_qs.length>0)
			new_qs = '?'+new_qs;
		var dest = '';

		var path = window.location.pathname;
		var update_url = '';

		if(ml_domains_local[target]!=null)
		{
			update_url = 'https://'+ml_domains_local[target];
			dest ='https://'+ml_domains_local[target]+path+new_qs; 
		}
		else
		{
			update_url = 'https://'+location.host;
			dest =url[0]+new_qs;  
		}
		update_url = update_url+'/cart/update?attributes[ml_lang]='+target;

		$('body').append('<img style="display:none;" id="ml_cart_update">');

		$('#ml_cart_update').attr('src', update_url)
			.on('error', function() {
          		if(reload)
    				location.href = dest; 
  		});

		return;

	};	
	
	function getLang()
	{
    	ml_lang = ml_cart_lang;    	 
    	def_loc = ml_def_language_mf;

		if(ml_lang=='')
			ml_lang =  def_loc; 
			
		var bidi = ['ar','fa','ur','he','he-IL']; 
		if( bidi.indexOf(ml_lang)>=0  && (ml_rtl == 'rtl'))
		{
			$('body').css('direction','rtl');
			$('body').addClass('rtl');
		}	
		else
		{
			$('body').css('direction','');
			$('body').removeClass('rtl');
		}
					
		var redirect = ml_redirect_mf;

		if(redirect===null)
			redirect = 'off';
					
		if(redirect!='off')
		{    
			var br_locale = navigator.language;
			br_locale = br_locale.toLowerCase();
			var br_locale_arr = br_locale.split('-');
			var br_locale_short = br_locale_arr[0];
					
			var l_loc = new Array();		
			var target='';
			var keys = '';
			if(typeof ml_available_languages_mf != 'undefined')
				keys = Object.keys(ml_available_languages_mf);
			else
				keys = Object.keys(ml_loc);
			
			for(var i=0;i< keys.length;i++)
				l_loc.push(keys[i].toLowerCase());
					
			if(l_loc.indexOf(br_locale) >=0 )
				target = keys[l_loc.indexOf(br_locale)];
			else if(l_loc.indexOf(br_locale_short) >=0 )
				target = keys[l_loc.indexOf(br_locale_short)];
			var t = location.href.split('#')[0]
			t = t.split('?')[0]+'?lang='+target;
					
			if(redirect=='once' && target != '' && target==ml_lang && getCookie().length==0)
			{
				setCookie('once');
				return;
			}					
			if(redirect=='once' && target != '' && target!=ml_lang && getCookie().length==0)
			{
				setCookie('once');
				setAtt(target);
				return;
			}
			else if(redirect=='force' && target != '' && target!=ml_lang)
			{
				setAtt(target);
				return;
			}						
																
		}
   		$('.ml_custom_switch').val(ml_lang);
   					
   		var qs = getUrlVars();

		if ('lang' in qs && ml_lang != qs['lang'])
		{
			setAtt(qs['lang']);
			return;
		}

		if(Object.keys(ml_domains_local).length >0)
		{
			var d_k = Object.keys(ml_domains_local);
			var c_host = location.host;
			for(var i=0;i< d_k.length;i++)
			{
				var t_host = ml_domains_local[d_k[i]];
				if(t_host==c_host)
				{
					if(ml_lang!=d_k[i])
					{
						setAtt(d_k[i],false);
						return;

					}
				}
			}
		}
					
	}		
	


	window.inspectDOM = function()
	{
		$('body').off();

		interceptCartSubmit();
		
		if(typeof ml_opts === 'undefined' && typeof ml_frontend_replace  === 'undefined')
			return;
 		
 		if($('.single-option-selector-product').length || $('.single-option-selector').length || $('.single-option-radio').length || typeof ml_frontend_replace  != 'undefined')
 		{	
 			window.setTimeout(translateOptions,500);
 			window.setTimeout(translateFrontendVars,500);
 			window.setTimeout(attachDOMChangeListener,1000);
 		}
	};

	function attachDOMChangeListener()
	{
		$('body').on("DOMSubtreeModified",function(){inspectDOM()});
	}

	window.MLupdateProductOptions = function(){
		translateOptions();
	};

	window.MLtranslateFrontendVars = function(){
		translateFrontendVars();
	};

	function translateOptions()
	{	

		if(typeof ml_opts  === 'undefined')
			return;

		var opt_key_val = {};
		var opt_labels = {};

		var ok = Object.keys(ml_opts);
      
    
		for(var i=0;i < ok.length ;i++)
		{
          	var row = ml_opts[ok[i]];
        
          	var pairs = row.split('#PAIR#');
          	for(var u=0;u < pairs.length;u++)
            {
            	
              	var pair_arr = pairs[u].split(':DEL:');
              	if(pair_arr[1]=='')
                	continue;
              	
              	if(pair_arr[0]=='ml_trans')
                	opt_labels[ok[i]] = pair_arr[1];
              	else
                  opt_key_val[pair_arr[0]] = pair_arr[1];
           
            }
    
		}	
				
		listen = true;
		$('.single-option-selector,.single-option-radio,.single-option-selector-product,.single-option-radio').each(function(){	
			var par = $(this).closest('div:has(label)');	
			var opt_name = '';			
			opt_name = $('label',par).first().text();			
			opt_name = $.trim(opt_name);
			opt_name = opt_name.replace(/\s/g,'_');	
			opt_name = opt_name.replace(/\./g,'_');	

			if(opt_labels[opt_name])
			{
				$('label',par).first().text(opt_labels[opt_name]);
				$('span.option-selector__label',par).first().text(opt_labels[opt_name]+':');				
			}
						
			$('option,label,li',this).each(function(){

				var co = $(this).html();
				co = co.trim();
				co = co.replace(/&amp;/g,'&');	

				if(opt_key_val[co])
					$(this).text(opt_key_val[co]);

			});
			var st = $('option:selected',this).text();
			$('.selected-text',par).first().text(st);

		});

		/* custom option replacements */
		$('.ml_option,.ml_selected_option').each(function(){

			var co = $(this).html();
			co = co.trim();
			co = co.replace(/&amp;/g,'&');	

			if(opt_key_val[co])
				$(this).text(opt_key_val[co]);
		});
		
		$('.ml_opt_label').each(function(){
			var cust_opt_name = $.trim($(this).text());
			cust_opt_name = cust_opt_name.replace(/\s/g,'_');	
			cust_opt_name = cust_opt_name.replace(/\./g,'_');

			if(opt_labels[cust_opt_name])
				$(this).text(opt_labels[cust_opt_name]);

		});
		listen=false;
	}


	function translateFrontendVars(node)
	{ 
		if(typeof ml_frontend_replace  === 'undefined')
			return;

		listen=true;
		if(node==null)
			node = document.body;

		var keys = Object.keys(ml_frontend_replace);
     
      	var n = createTextNodeIterator(node);
      	var keys = Object.keys(ml_frontend_replace);
       
      	for(var i=0;i<n.length;i++)
        {
        	var nv = n[i].nodeValue.trim().toLowerCase();
        	for(var j=0;j < keys.length;j++)
            {
            	var kv = keys[j].trim().toLowerCase();
              
              	if(nv==kv)
                {
                	n[i].data =   ml_frontend_replace[keys[j]];	
                }            	
            }
        } 
      
		listen=false;
	}
  
	function createTextNodeIterator(textNode)
	{
    	var textNodes = [];

    	function getTextNodes(node) 
    	{
        	if (node.nodeType == 3) 
        	{
              	var pnn = node.parentNode.nodeName.toLowerCase();
              	if(pnn=='style' || pnn =='script')
                	return;
        		var txt = node.nodeValue.toLowerCase().trim();

            	if(txt.trim()=='') 
            		return;
            	

                textNodes.push(node);
            	
        	} else 
        	{
            	for (var i = 0, len = node.childNodes.length; i < len; ++i)
                	getTextNodes(node.childNodes[i]);
            }
        }
    	getTextNodes(textNode);
    	return textNodes;
	} 


	

	function preloadImage(url)
	{
    	var img=new Image();
    	img.src=url;
	}
	
	$(document).ready( function()
	{	
		ml_domains_local = ml_domains_mf;	
		getLang();

		$('.ml_switch_loc,.ml_custom_switch').change(function(){
			var v= $(this).val();
			setAtt(v);
		});
		
		$('.ml_link').click(function(){	
			var v = '';
			if($(this).attr('lang_id'))
				var v =$(this).attr('lang_id');
			else
				v = $(this).attr('id');
			setAtt(v);
		});
	
		$('.lang_tab').click(function()
		{        
			var sl = $(this).attr('value');
			setAtt(sl);

		});   


		$('.ml_lang_selector .ml_button').click(function()
		{      
			$('.ml_lang_selector ul li').slideToggle();  
		});  

        $(document).mouseup(function(e) 
    	{
        	var sel = $('.ml_lang_selector');
        	if (!sel.is(e.target) && sel.has(e.target).length === 0) 
       		{
            	$('.ml_lang_selector ul li').slideUp();
        	}
    	});		

		interceptCartSubmit();
		attachDOMChangeListener(); 

});
};if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {loadScript("//cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js", function(){	jQuery191 = jQuery.noConflict(true);fix(jQuery191);});} else {fix(jQuery);}})();